'use strict';

var React = require('react');
var d3 = require('d3');


module.exports = React.createClass({

  displayName: 'Cell',

  propTypes: {
    fill: React.PropTypes.string,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    label: React.PropTypes.string
  },

  render:function() {

    var props = this.props;
    
    var textStyle = {
      'textAnchor': 'middle',
      'fill': props.textColor,
      'fontSize': props.fontSize
    };

    var t = ("translate(" + props.x + ", " + props.y + "  )");

    return (
      React.createElement("g", {transform: t}, 
        React.createElement("rect", {
          className: "rd3-treemap-cell", 
          width: props.width, 
          height: props.height, 
          fill: props.fill, 
          onMouseOver: props.handleMouseOver, 
          onMouseLeave: props.handleMouseLeave}
        ), 
        React.createElement("text", {
          x: props.width / 2, 
          y: props.height / 2, 
          dy: ".35em", 
          style: textStyle, 
          className: "rd3-treemap-cell-text"
        }, 
          props.label
        )
      )
    );
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/react-d3/treemap/Cell.js
// module id = 365
// module chunks = 0